import { llm } from '@cotera/api';
import type { ToolSet } from 'ai';
import type { CoteraToolDefinition } from './cotera-tool-definition';
import { modelAdapterFor } from './model-input-adapter';

export type { CoteraToolDefinition } from './cotera-tool-definition';

type CoteraModel = NonNullable<ReturnType<typeof llm.getModel>>;

/**
 * Map loaded tool definitions to streamText tool schemas (no `execute`).
 * Delegates to {@link modelAdapterFor} for provider-specific {@link augmentDefinition}.
 */
export const renderPreparedTools = (
  toolDefinitions: readonly CoteraToolDefinition[],
  model: CoteraModel
): ToolSet => modelAdapterFor(model.id).renderTools(toolDefinitions);
